import React from 'react'
import { Grid } from '@mui/material'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import { State } from '@hookstate/core'
import IInvolvementType from '~/features/InvolvementType/interfaces/IInvolvementType'
import IPeopleCircunstance from '~/features/PeopleCircunstance/interfaces/IPeopleCircunstance'
import IDestination from '~/features/Destination/interfaces/IDestination'

interface InvolvedFiltersProps {
  readonly involvedTypeFilter?: boolean
  readonly arrestedFilter?: boolean
  readonly peopleCircunstanceFilter?: boolean
  readonly destinationFinalFilter?: boolean
  readonly involvedType:  State<IInvolvementType | null>
  readonly arrestedId:  State<number | null>
  readonly peopleCircunstanceId:  State<IPeopleCircunstance | null>
  readonly destinationInvolvedId:   State<IDestination | null>
  readonly getInvolvementTypes: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getArrestedValues: any
  readonly getPeopleCircunstances: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getDestinations: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly translate: (key: string) => string
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: State<string>
}

export default function InvolvedFilters({
  involvedTypeFilter,
  arrestedFilter,
  peopleCircunstanceFilter,
  destinationFinalFilter,
  involvedType,
  arrestedId,
  peopleCircunstanceId,
  destinationInvolvedId,
  getInvolvementTypes,
  getArrestedValues,
  getPeopleCircunstances,
  getDestinations,
  translate,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: InvolvedFiltersProps) {
  return (
    <>
      {involvedTypeFilter && (
        <Grid item xs={2.05} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            onValueChange={(type) => involvedType.set(type)}
            valueId={involvedType.get()?.id as string}
            optionsFetch={getInvolvementTypes}
            label={translate('Involvement Type')}
            disabled={disableFields}
          />
        </Grid>
      )}
      {arrestedFilter && (
        <Grid item xs={2.01} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            label={translate('Arrested')}
            onValueChange={(arrested) => arrestedId.set(Number(arrested?.id))}
            optionsList={getArrestedValues().map((arrestedMap: string, index: number) => ({
              id: `${index}`,
              name: arrestedMap,
            }))}
            valueId={String(arrestedId.get())}
            disabled={disableFields}
          />
        </Grid>
      )}
      {peopleCircunstanceFilter && (
        <Grid item xs={1.99} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            label={translate('People Circunstance')}
            onValueChange={(peopleCircunstance) => peopleCircunstanceId.set(peopleCircunstance)}
            valueId={peopleCircunstanceId.get()?.id as string}
            optionsFetch={getPeopleCircunstances}
            disabled={disableFields}
          />
        </Grid>
      )}
      {destinationFinalFilter && (
        <Grid item xs={2.05} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            label={translate('Destination')}
            onValueChange={(destination) => destinationInvolvedId.set(destination)}
            valueId={destinationInvolvedId.get()?.id as string}
            optionsFetch={getDestinations}
            disabled={disableFields}
          />
        </Grid>
      )}
      <Grid container>
        <FilterSelectPeriod
          required
          onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
          onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
          onPeriodChange={(value) => initialPeriod.set(value)}
          period={initialPeriod.get()}
          sxPeriod={{ pl: 0, pt: 1 }}
        />
      </Grid>
    </>
  )
}